import React from 'react';
import { Popup, Input, CustomButton, ToastNotification, WithLoadingComponent, SkeletonLoader, MulSelect, IconsUtility } from "components/shared";
import { SkillService } from "services/http";
import utils from 'utils';

/**
 * Skill form component [CREATE, UPDATE]
 * @param {Object} props { title, display, hideFnc, skill }
 * @returns React.Component
 */
export const SkillFormTemplate = (props) => {

    const { title, display, hideFnc, skill } = props;
    const toastRef = React.useRef();
    const [skillObj, setSkillObj] = React.useState(skill);
    const [skillPrerequisites, setSkillPrerequisites] = React.useState();

    /**
     * Init skill payload for update action
     */
    React.useEffect(() => {
        setSkillObj(skill);
    }, [skill]);

    /**
     * Form submission action
     * @param {Event} e event listner
     */
    const onFormSubmission = (e) => {
        e.preventDefault();
        let payload = { ...skillObj, ...skillPrerequisites };
        let Promise = !Object.keys(skill).length ? SkillService.addNewSkill(payload) : SkillService.updateSkillItem(payload);
        Promise.then((response) => {
            props.hideFnc();
            props.successCallback(response.message);
        }, error => {
            props.errorCallback(error);
        });
    }

    return (
        <>
            <Popup
                header={title}
                visible={display}
                onHide={hideFnc}>
                <form onSubmit={onFormSubmission} style={{ width: "25vw" }}>
                    <Input
                        id="skill-name"
                        placeholder="Name *"
                        required
                        value={skillObj.competenceName}
                        parentClass="my-2"
                        onChange={(e) => { setSkillObj({ ...skillObj, competenceName: e.target.value }) }}
                        icon="bi bi-lightbulb"
                    />
                    <Input
                        id="skill-description"
                        placeholder="Description *"
                        required
                        value={skillObj.description}
                        onChange={(e) => { setSkillObj({ ...skillObj, description: e.target.value }) }}
                        icon="bi bi-bookmarks"
                    />
                    <SkillCriteriasHoc skillPayload={skillObj} skillFillCallback={(options) => setSkillPrerequisites(options)} />
                    <hr />
                    <div className="my-2 w-100 d-flex">
                        <CustomButton
                            label={<><i className="bi bi-x-circle" />  CANCEL</>}
                            style={{ width: "50%" }}
                            className="p-button-warning"
                            onClick={(e) => { e.preventDefault(); props.hideFnc() }} />&nbsp;
                        <CustomButton
                            label={utils.labelTemplate(<><i className="bi bi-check-circle" /> SAVE</>, false, "Processing...")}
                            type="submit"
                            className={false && "not-allowed"}
                            style={{ width: "50%" }}
                        />
                    </div>
                </form>
            </Popup>
            <ToastNotification ref={toastRef} />
        </>
    );
}

/**
 * Skill prerequites wrapper component
 * @param {Object} props { tags, statuses, teams, sources } 
 * @returns React.Component
 */
const SkillOptionsWrapper = (props) => {
    const sources = props.data;
    let { skillPayload } = props;
    const [selectedOptions, setSelectedOptions] = React.useState({});
    const [items2dispatch, setItems2dispatch] = React.useState({});

    /**
     * Init skill options for update action
     */
    React.useEffect(() => {
        if (Object.keys(skillPayload).length) {
            let sources = skillPayload?.sources.map(item => item.sourceId);
            setSelectedOptions({ ...selectedOptions, sources });
        }
    }, [skillPayload]);

    /**
     * Handle multiselect state changing
     * @param {Object} props { event, criteriaSet, criteriaItem }
     */
    const handleChangeSelect = ({ event, criteriaSet, criteriaItem }) => {
        setSelectedOptions({ ...selectedOptions, [criteriaSet]: event.value });
        let options = { ...items2dispatch, [criteriaSet]: event.value.map(item => { let obj = {}; obj[criteriaItem] = item; return obj; }) };
        setItems2dispatch(options);
        props.skillFillCallback(options);
    }

    /**
     * Skill MultiSelects Utilities
     */
    const SOURCE_MU_SELECTS = {
        name: "sources",
        placeholder: "Sources",
        options: sources,
        icon: "bi bi-inboxes",
        optionLabel: "description",
        optionValue: "sourceId",
        onChange: (e) => handleChangeSelect({ event: e, criteriaSet: "sources", criteriaItem: "sourceId" }),
        value: selectedOptions.sources
    }

    return <MulSelect {...SOURCE_MU_SELECTS} />
}

/**
 * Skill Options Higher Order Component
 * @param {Object} props 
 * @returns React.Component
 */
const SkillCriteriasHoc = (props) => {
    const Hoc = React.useMemo(() => WithLoadingComponent(SkillOptionsWrapper, () => SkillService.getSources(), <SkeletonLoader rectangle factor={4} />)(props), []);
    return <Hoc />
}